"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSettings = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SETTINGS", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M9.52.733C9.508.523 9.45.311 9.263.214 9.056.108 8.68 0 8 0S6.944.108 6.738.214c-.187.097-.245.31-.259.52L6.381 2.22c-.466.13-.91.316-1.322.548l-1.122-.983c-.158-.138-.35-.248-.55-.184-.22.07-.563.26-1.044.741-.48.48-.67.824-.74 1.044-.065.2.045.392.183.55L2.77 5.06a5.963 5.963 0 0 0-.548 1.322l-1.488.098c-.21.014-.422.072-.519.26C.108 6.943 0 7.32 0 8c0 .68.108 1.056.214 1.262.097.187.31.245.52.259l1.487.098c.13.466.315.91.548 1.322l-.983 1.122c-.138.158-.248.35-.184.55.07.22.26.563.741 1.044.48.48.823.67 1.044.74.2.065.392-.045.55-.183l1.122-.983c.413.233.856.418 1.322.548l.098 1.488c.014.21.072.422.26.519.205.106.581.214 1.261.214.68 0 1.056-.108 1.262-.214.187-.097.245-.31.259-.52l.098-1.487c.466-.13.91-.315 1.322-.548l1.122.983c.158.138.35.248.55.184.22-.07.563-.26 1.044-.741.48-.48.67-.823.74-1.044.065-.2-.045-.392-.183-.55l-.983-1.122c.233-.413.418-.856.548-1.322l1.488-.098c.21-.014.422-.072.519-.26.106-.205.214-.581.214-1.261 0-.68-.108-1.056-.214-1.262-.097-.187-.31-.245-.52-.259l-1.487-.098a5.961 5.961 0 0 0-.548-1.322l.983-1.122c.138-.158.248-.35.184-.55-.07-.22-.26-.563-.741-1.044-.48-.48-.823-.67-1.044-.74-.2-.065-.392.045-.55.183l-1.122.983a5.963 5.963 0 0 0-1.322-.548L9.521.733ZM8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z" }))); };
exports.default = SvgSettings;
